import title from "../../assets/img/xscape/nx1.jpg"
import overview from "../../assets/img/xscape/nx2.png"
import problem from "../../assets/img/xscape/nx3.png"
import analysis from "../../assets/img/xscape/nx4.jpg"
import persona from "../../assets/img/xscape/nx5.png"
import storyboard from "../../assets/img/xscape/nx6.png"
import userflow from "../../assets/img/xscape/nx7.png"
import brand from "../../assets/img/xscape/nx8.png"
import wireframes from "../../assets/img/xscape/nx9.png"
import lowfi1 from "../../assets/img/xscape/nx10.png"
import lowfi2 from "../../assets/img/xscape/nx11.png"
import hifi1 from "../../assets/img/xscape/nx12.jpg"
import hifi2 from "../../assets/img/xscape/nx13.jpg"


export default function NorthenXscape() {
    return (
        <main className="portfolioDetail">
            <h1>Northen Xscape - UX Case Study</h1>
            <img src={title} alt="Title" loading="lazy" />
            <img src={overview} alt="overview" loading="lazy" />
            <img src={problem} alt="problem" loading="lazy" />
            <img src={analysis} alt="analysis" loading="lazy" />
            <img src={persona} alt="persona" loading="lazy" />
            <img src={storyboard} alt="storyboard" loading="lazy" />
            <img src={userflow} alt="userflow" loading="lazy" />
            <img src={brand} alt="brand" loading="lazy" />
            <img src={wireframes} alt="wireframes" loading="lazy" />
            <img src={lowfi1} alt="lowfi1" loading="lazy" />
            <img src={lowfi2} alt="lowfi2" loading="lazy" />
            <img src={hifi1} alt="hifi1" loading="lazy" />
            <img src={hifi2} alt="hifi2" loading="lazy" />
        </main>
    );
  }